// The 42 ad-platform ISO codes PolyLLM uses DIRECTLY as URL prefix, i18n lng,
// and translation folder name. 'en' is intentionally NOT here (it is the
// fallback target, not an advertising language).
export const POLYLLM_LOCALES = [
  'zh',
  'hi',
  'es',
  'fr',
  'ms',
  'bn',
  'pt',
  'id',
  'de',
  'ja',
  'mr',
  'te',
  'tr',
  'ta',
  'vi',
  'ko',
  'it',
  'th',
  'gu',
  'kn',
  'pl',
  'ml',
  'ro',
  'nl',
  'tl',
  'uk',
  'sr',
  'cs',
  'el',
  'sv',
  'hu',
  'da',
  'fi',
  'no',
  'bg',
  'sk',
  'lt',
  'lv',
  'et',
  'hr',
  'ca',
  'sl',
] as const;

export type PolyllmLocale = (typeof POLYLLM_LOCALES)[number];

export const POLYLLM_DEFAULT_LOCALE = 'en';

const LOCALE_SET = new Set<string>(POLYLLM_LOCALES);

export const isPolyllmLocale = (v: string): v is PolyllmLocale =>
  LOCALE_SET.has(v);
